import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, primeCsrf } from './api';
import type { Paginated } from './paginated';
import type { ClientRequestData } from '@/types/api';

export type NewRequestInput = {
  client_id: number;
  type: string;
  subject: string;
  body: string;
};

export function usePortalRequests() {
  return useQuery({
    queryKey: ['portal-requests'],
    queryFn: async (): Promise<Paginated<ClientRequestData>> => {
      const { data } = await api.get<Paginated<ClientRequestData>>('/v1/portal/requests');
      return data;
    },
  });
}

export function useCreatePortalRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: NewRequestInput): Promise<ClientRequestData> => {
      await primeCsrf();
      const { data } = await api.post<ClientRequestData>('/v1/portal/requests', input);
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['portal-requests'] }),
  });
}
